if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;
        this.prependMedia = this.dataset.disablePrepend != 'true';      
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend && this.prependMedia) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({behavior: 'smooth'});
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        
        if ( activeMedia.querySelector('.internal-video--playing video')) {
          activeMedia.querySelector('video').play();

        }
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

/* ===== CHALYNE — bascule complète de la galerie au changement de coloris ===== */
(function () {
  if (window.__chaVariantGallery) return;
  window.__chaVariantGallery = true;

  var lastVariantId = null;
  var pending = 0;

  function currentVariantId(scope) {
    var input = scope.querySelector('input[name="id"]');
    return input ? input.value : null;
  }

  function refresh(scope, variantId) {
    if (!scope || !variantId) return;
    variantId = String(variantId);
    if (variantId === lastVariantId) return;
    lastVariantId = variantId;

    var sectionId = scope.dataset.originalSection || scope.dataset.section;
    if (!sectionId) return;

    var base = scope.dataset.url || window.location.pathname;
    var url = base + '?variant=' + variantId + '&section_id=' + sectionId;
    var ticket = ++pending;

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        if (ticket !== pending) return;
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var next = doc.querySelector('media-gallery');
        var live = scope.querySelector('media-gallery');
        if (!next || !live) return;
        live.replaceWith(next);
        if (typeof enableZoomOnHover === 'function' && scope.hasAttribute('data-zoom-on-hover')) {
          try { enableZoomOnHover(2); } catch (e) {}
        }
      })
      .catch(function () {});
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var first = document.querySelector('product-info');
    if (first) lastVariantId = currentVariantId(first);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data;
        if (!data || !data.variant || !data.sectionId) return;
        var scope = document.querySelector('product-info[data-section="' + data.sectionId + '"]');
        refresh(scope, data.variant.id);
      });
    }

    document.addEventListener(
      'change',
      function (e) {
        var target = e.target;
        if (!target || !target.closest) return;
        var picker = target.closest('variant-selects');
        if (!picker) return;
        var scope = picker.closest('product-info');
        if (!scope) return;
        setTimeout(function () {
          refresh(scope, currentVariantId(scope));
        }, 700);
      },
      true
    );
  });
})();

/* ===== CHALYNE — filet de sécurité sur le bouton d'ajout au panier =====
   Le thème désactive le bouton dès le clic sur un coloris, puis compte sur
   sa propre chaîne de mise à jour pour le réactiver. Quand cette chaîne
   échoue, le bouton reste mort jusqu'au rechargement de la page.
   Ici on relit la disponibilité réelle de la variante sélectionnée dans les
   données publiées par le thème, et on remet le bouton dans l'état correct. */
(function () {
  if (window.__chaAtcGuard) return;
  window.__chaAtcGuard = true;

  function variantList(scope) {
    var scripts = scope.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var parsed = JSON.parse(scripts[i].textContent);
        if (Array.isArray(parsed) && parsed.length && parsed[0] && 'available' in parsed[0]) {
          return parsed;
        }
      } catch (e) {}
    }
    return null;
  }

  function isAvailable(scope) {
    var input = scope.querySelector('input[name="id"]');
    if (!input || !input.value) return null;
    var list = variantList(scope);
    if (!list) return null;
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(input.value)) return list[i].available !== false;
    }
    return null;
  }

  function label(available) {
    var strings = window.variantStrings || {};
    return available ? (strings.addToCart || 'Ajouter au panier') : (strings.soldOut || 'Épuisé');
  }

  function fix(scope) {
    if (!scope) return;
    var available = isAvailable(scope);
    if (available === null) return;

    scope.querySelectorAll('product-form .product-form__submit').forEach(function (button) {
      if (available) {
        button.removeAttribute('disabled');
        button.classList.remove('disabled');
      } else {
        button.setAttribute('disabled', 'disabled');
      }
      var span = button.querySelector('span');
      if (span && !span.classList.contains('loading__spinner')) {
        span.textContent = label(available);
      }
    });
  }

  function scheduleAll() {
    [250, 700, 1400, 2200].forEach(function (delay) {
      setTimeout(function () {
        document.querySelectorAll('product-info').forEach(fix);
      }, delay);
    });
  }

  document.addEventListener(
    'change',
    function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('variant-selects') || e.target.closest('quantity-breaks')) scheduleAll();
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('variant-selects') || e.target.closest('quantity-breaks')) scheduleAll();
    },
    true
  );
})();
